import { useCallback, useState } from 'react'

export const useStateToggle = (initialState?: boolean): [boolean, () => void] => {
  const [state, setState] = useState(initialState)
  const toggleState = useCallback((newState?: boolean) => {
    setState(prev => (typeof newState === 'undefined' ? !prev : newState))
  }, [])
  return [!!state, toggleState]
}
